import { render, staticRenderFns } from "./AppChatStampList.vue?vue&type=template&id=da69f020&scoped=true&"
import script from "./AppChatStampList.vue?vue&type=script&lang=ts&"
export * from "./AppChatStampList.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatStampList.vue?vue&type=style&index=0&id=da69f020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69f020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VRow,VSpacer})
